module.exports = __webpack_public_path__ + "img/Black-and-white-shaded-earth-tattoo-with-compass-on-inner-arm.jpg";